// @flow

import * as React from 'react';

import TableCell from '@mui/material/TableCell';

import Chip from 'app/common/chip';

export default ({ children, column }) => {
  return (
    <TableCell
      padding={column.disablePadding ? 'none' : column.padding || 'checkbox'}
    >
      <Chip template={children.toLowerCase()} />
    </TableCell>
  );
};